import React from 'react';
import { AlertTriangleIcon, TrendingUpIcon, BarChart4Icon, AlertCircleIcon, ActivityIcon, ClockIcon, DownloadIcon, CheckCircleIcon } from 'lucide-react';
export const InsightsSection = () => {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-176">
      {/* Risikosignaler */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4" data-id="element-177">
        <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center gap-1" data-id="element-178">
          <AlertTriangleIcon size={16} className="text-yellow-500 flex-shrink-0" data-id="element-179" />
          <span className="truncate" data-id="element-180">Risikosignaler</span>
        </h3>
        <div className="space-y-2" data-id="element-181">
          <div className="flex items-start gap-2 text-xs" data-id="element-182">
            <AlertCircleIcon size={14} className="text-yellow-500 mt-0.5 flex-shrink-0" data-id="element-183" />
            <span className="truncate" data-id="element-184">4 besøg, 0 henvendelser</span>
          </div>
          <div className="flex items-start gap-2 text-xs" data-id="element-185">
            <ClockIcon size={14} className="text-yellow-500 mt-0.5 flex-shrink-0" data-id="element-186" />
            <span className="truncate" data-id="element-187">
              Lang tid på Fragt & Rabatter (03:45)
            </span>
          </div>
          <div className="flex items-start gap-2 text-xs" data-id="element-188">
            <DownloadIcon size={14} className="text-yellow-500 mt-0.5 flex-shrink-0" data-id="element-189" />
            <span className="truncate" data-id="element-190">Gentagne downloads uden accept</span>
          </div>
        </div>
      </div>
      {/* Købsintention */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4" data-id="element-191">
        <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center gap-1" data-id="element-192">
          <CheckCircleIcon size={16} className="text-green-500 flex-shrink-0" data-id="element-193" />
          <span className="truncate" data-id="element-194">Købsintention</span>
        </h3>
        <div className="flex items-center justify-between" data-id="element-195">
          <div className="text-xs text-gray-600" data-id="element-196">
            <div className="mb-1 truncate" data-id="element-197">Baseret på:</div>
            <div className="flex items-center gap-1" data-id="element-198">
              <span className="w-2 h-2 rounded-full bg-green-500 flex-shrink-0" data-id="element-199"></span>
              <span className="truncate" data-id="element-200">5 besøg</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-201">
              <span className="w-2 h-2 rounded-full bg-green-500 flex-shrink-0" data-id="element-202"></span>
              <span className="truncate" data-id="element-203">18:23 min. samlet tid</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-204">
              <span className="w-2 h-2 rounded-full bg-yellow-500 flex-shrink-0" data-id="element-205"></span>
              <span className="truncate" data-id="element-206">Sammenligning set</span>
            </div>
          </div>
          <div className="flex flex-col items-center ml-2" data-id="element-207">
            <div className="w-16 h-16 rounded-full border-4 border-green-500 flex items-center justify-center" data-id="element-208">
              <span className="text-xl font-bold text-green-600" data-id="element-209">75%</span>
            </div>
            <span className="text-xs font-medium text-green-600 mt-1" data-id="element-210">Høj</span>
          </div>
        </div>
      </div>
      {/* Scenarie-trend */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4" data-id="element-211">
        <h3 className="text-sm font-medium text-gray-700 mb-3 flex items-center gap-1" data-id="element-212">
          <TrendingUpIcon size={16} className="text-blue-500 flex-shrink-0" data-id="element-213" />
          <span className="truncate" data-id="element-214">Scenarie-trend</span>
        </h3>
        <div className="h-28 flex items-end gap-3 justify-center mt-2" data-id="element-215">
          <div className="flex flex-col items-center" data-id="element-216">
            <div className="h-20 w-16 relative" data-id="element-217">
              <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-218">
                <path d="M0,90 L10,80 L20,85 L30,70 L40,75 L50,60 L60,50 L70,55 L80,40 L90,30 L100,35" stroke="#93c5fd" strokeWidth="4" fill="none" data-id="element-219" />
              </svg>
            </div>
            <span className="text-xs font-medium" data-id="element-220">Good</span>
          </div>
          <div className="flex flex-col items-center" data-id="element-221">
            <div className="h-20 w-16 relative" data-id="element-222">
              <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-223">
                <path d="M0,70 L10,60 L20,65 L30,50 L40,45 L50,30 L60,25 L70,30 L80,20 L90,15 L100,10" stroke="#3b82f6" strokeWidth="4" fill="none" data-id="element-224" />
              </svg>
            </div>
            <span className="text-xs font-medium" data-id="element-225">Better</span>
          </div>
          <div className="flex flex-col items-center" data-id="element-226">
            <div className="h-20 w-16 relative" data-id="element-227">
              <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-228">
                <path d="M0,80 L10,85 L20,75 L30,80 L40,70 L50,75 L60,65 L70,60 L80,50 L90,40 L100,30" stroke="#1d4ed8" strokeWidth="4" fill="none" data-id="element-229" />
              </svg>
            </div>
            <span className="text-xs font-medium" data-id="element-230">Best</span>
          </div>
        </div>
        <div className="text-xs text-gray-500 text-center mt-2 truncate" data-id="element-231">
          Tendens: Øget interesse for Better-scenariet
        </div>
      </div>
    </div>;
};